// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__kICMw","selected":"Chip_selected__OdHhk"};